import React from 'react';
import { UserRoles } from 'types';
import { Redirect, Route } from 'react-router-dom';
import { useRoleAccess } from 'hooks/useRoleAccess';
import { RouteProps } from 'react-router';

interface IProtectedRoute {
	permittedRoles: UserRoles[];
}

const ProtectedRoute: React.FC<IProtectedRoute & RouteProps> = ({ permittedRoles, ...props }) => {
	const hasAccess = useRoleAccess(permittedRoles);

	return hasAccess ? <Route {...props} /> : <Redirect to="/home" />;
};

export default ProtectedRoute;
